import React from 'react'

const BlueButton = (props) => {
     return (
          <button disabled={props.disabled} onClick={props.onClick} className={`hover:opacity-70 bg-blue rounded-2xl text-[1.4rem] font-bold text-white ltr:tracking-wider duration-700 transition-all ${props.className}`}>{props.children}</button>
     )
}

export default BlueButton